import React, { useEffect } from "react";
import "../css/MenuStart.css";
import { makeStyles } from "@material-ui/core/styles";
import { List } from "@material-ui/core";

import MainScreen from "./templates/MainScreen";
import CategoryItem from "../components/CategoryItem";

import routes from "../../utils/routes.json";

import { getCategoriesInfo } from "../../viewmodel/providers/categoriesInfo";
import { useCategory } from "../../viewmodel/hooks/getCategory";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

const useStyles = makeStyles({
    list: {
        "& > :not(:last-child)": {
            marginBottom: "0.8rem",
        },
    },
});

type PlayMode = {
    mode: string;
}

type locationState = {
    opponentId: string,
    confirm: boolean,
}

export default function CategoryMenu({ mode }: PlayMode): JSX.Element {

    const { t } = useTranslation();

    const styles = useStyles();
    const [state, setCategories] = useCategory();

    useEffect(() => {
        getCategoriesInfo(setCategories);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const location: locationState = useLocation<locationState>().state;
    
    const categoriesItems =
        state.categories.map((item) => <CategoryItem key={item.id} categoryIds={[item.id]} name={item.descr} mode={mode} opponentId={location?.opponentId} />);
    if (state.categories.length !== 0)
        categoriesItems.unshift(
            <CategoryItem key={"all"} categoryIds={state.categories.map((item) => item.id)} name={t("categories.all")} mode={mode} opponentId={location?.opponentId} />,
        );

    return (
        <MainScreen lower={false} back={true} backPath={routes.menu}>
            <List className={styles.list}>
                {categoriesItems}
            </List>
        </MainScreen>
    );
}
